import { ADD, REMOVE } from './known-class-actions';
import arrayFindIndex from 'array-find-index';

import moment from 'moment/moment';
import { createReducer } from '../redux-util/general-helpers';

const handlers = {
  [ADD]: (state, action) => {
    if (!action.code || !action.name) {
      return state;
    }

    const classes = state.slice();
    const index = arrayFindIndex(classes, c => c.code === action.code);

    if (index !== -1) {
      const existingClass = classes[index];
      classes[index] = {
        ...existingClass,
        name: action.name,
      };
    } else {
      classes.push({
        code: action.code,
        name: action.name,
        expires: moment()
          .add(11, 'months')
          .format(),
      });
    }
    return classes;
  },
  [REMOVE]: (state, action) => {
    const index = arrayFindIndex(state, el => el.code === action.code);
    if (index !== -1) {
      const classes = state.slice();
      classes.splice(index, 1);
      return classes;
    }
    return state;
  },
};

export default createReducer([], handlers);
